export default __webpack_public_path__ + "static/media/logo.8c18a0e1.png";